<template>
	<div class="bg-white flex-sub radius-20 all margin-left">
		<div class="mobel">{{userInfo.miPhone}}</div>
		<!-- 验证码输入框 start -->
		<div class="main-center">
			<div class="code" :style="[{ 'margin-left':'-'+ (boxNum/2 * 86)+ 'rpx'}]">
				<div class="code-box" @click="showKeyBoard">
					<!-- <div class="code-box-item">
						{{ (password[index] && '●') || '' }}</div> -->
					<input maxlength="4" class="code-box-item" type="number"  v-model="password" />
				</div>
				<!-- <input type="number"  v-model="password" /> -->
			</div>
		</div>
		<!-- 验证码输入框 end -->
		<!-- 获取验证码 start -->
		<div class="padding fu-flex pointer fu-flex-center text-blue2" @click="getCode">
			{{ beginning ? time + "s后重新获取" : "获取" }}
		</div>
		<!-- 获取验证码 end -->

		<!-- 下一步按钮 start -->
		<div class="btn_cloce">
			<div class="types" @click="submit">下一步</div>
		</div>
		<!-- 下一步按钮 end -->
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				boxNum:4,        //验证码输入框的个数
				password: '',  //输入的验证码
				code: "", // {String} 验证码
				getCodeText: "获取验证码", // {String} 获取验证码按钮的文字
				getCodeisWaiting: false, // {Boolean} 获取验证码时的加载状态
				beginning: false, // 显示倒计时,@Boolean
				time: 60, // 倒计时60S,@Number
				timer: null, // 计时器,@Function
			}
		},
		computed: {
			userInfo() {
				if (this.$store.getters.userInfo) {
					return this.$store.getters.userInfo;
				} else {
					return JSON.parse(localStorage.getItem('USER_INFO'));
				}
			}
		},
		created() {
			console.log(this.userInfo);
		},
		methods:{
			/**
			 * 获取验证码
			 * */
			getCode(){
				let _this = this;
				// 如果有倒计时，return false
				if (this.beginning) return false;
				this.beginning = true; // 显示倒计时
				this.ajax('get', '/api/pc/user/getPhoneCode', {
					phone: this.userInfo.phone,
					stat:1,
				}, res => {
					if (res.status == 200) {
						// 清除倒计时,防抖作用
						clearInterval(_this.timer);
						_this.timer = setInterval(() => {
						  if (_this.time == 1) {
						    //倒计时结束就清楚这个倒计时
						    clearInterval(_this.timer);
						    _this.time = 60; // 倒计时60s
						    _this.beginning = false; // 是否显示倒计时改为false
						    return;
						  }
						  _this.time--;
						}, 1000);
					} else {
						_this.beginning = false; // 是否显示倒计时改为false
					}
				})
			},
			showKeyBoard(){
				
			},
			submit(){
				
				const that = this
				// 验证信息 start
				// if (!this.code_id) {
				//   this.$message.info("请先获取验证码");
				//   return false;
				// }
				if (!this.password ) {
				  this.$message.info("请输入验证码");
				  return false;
				}
				// 验证信息 end
				this.ajax('get', '/api/user/verificationCode', {
					code:this.password
				}, res => {
					if (res.status == 200) {
						let type = {
							type:'setpas',
							typeone:''
						}
						this.$emit('gettype',type)
					} else {
						
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.all{
		padding-top: 50px;
	}
	.mobel{
		font-size: 25px;
	}
	.main-center {
	  height: 80px;
	  width: 100%;
	  
	}
	.code {
	  height: 80px;
	  margin-top: 32px;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  
	}
	.code-box {
	  display: flex;
	  flex-direction: row;
	  justify-content: center;
	  align-items: center;
	  
	}
	.text-blue2{
	  color: #3B9DFF;
	}
		
	.code-box-item {
	  // width: 60px;
	  height: 60px;
	  background: #fff;
	  font-size: 30px;
	  line-height: 60px;
	  text-align: center;
	  border: 1px solid #d0d0d0;
	}
	.radius-20{
		border-radius: 20px;
	}
	// 下一步按钮 start
	.btn_cloce {
	  margin-top: 32px;
	  width: 100%;
	  text-align: center;
	  .types {
		  width: 383px;
		  height: 60px;
		  background: #09827B;
		  box-shadow: 3px 4px 38px 2px rgba(9,130,123,0.2);
		  border-radius: 30px;
		  margin: 0 auto;
		  
	    
	    color: #ffffff;
	    line-height: 60px;

	    
	  }
	}
	// 下一步按钮 end
</style>



// WEBPACK FOOTER //
// src/components/my/password/set.vue